/*
 * @Description: 测线控制器
 */

import { ReportControllerFac } from './_utils'

const BASE_URL = `/api/organization/orderDetail/line`
const ApiController = new ReportControllerFac(BASE_URL)

export default ApiController
